import { useTranslation } from "react-i18next";

import directions from "@/assets/directions.svg"

interface DirectionsProps {
    destinationLat: number;
    destinationLng: number;
    whiteIcon?: boolean
    onlyIcon?: boolean
    class?: string
    iconColor?: string
}
import { ReactSVG } from "react-svg";
import { colors } from "@/theme/theme";
import { Button } from "@heroui/react";
import { useSelector } from "react-redux";
import { RootState } from "@/store/store";

const Directions: React.FC<DirectionsProps> = (props) => {
    const { t } = useTranslation(["common", "validation", "glossary"]);
    //const { userLatitude, userLongitude } = useGeolocation();

    const userLatitude = useSelector((state: RootState) => state.geolocation.latitude)
    const userLongitude = useSelector((state: RootState) => state.geolocation.longitude);

    const generateMapLink = () => {
        if (userLatitude !== null && userLongitude !== null) {
            return `https://www.google.com/maps/dir/${userLatitude},${userLongitude}/${props.destinationLat},${props.destinationLng}`;
        } else {
            return `https://www.google.com/maps/place/${props.destinationLat},${props.destinationLng}`;
        }
    };
    return (

        props.destinationLat && props.destinationLng &&
        <a href={generateMapLink()} target="_blank">
            <Button
                isIconOnly={props.onlyIcon}
                title={t("directions", { ns: "glossary" })}
                className={
                    `${props.whiteIcon ? ' bg-white h-10 w-10 border-black' : 'hover:bg-primary/80 bg-primary'}  transition-all ${props.onlyIcon ? ' rounded-full p-1' : 'rounded-md lg:min-w-40 p-1'} px-4 border ${props.class}`
                }
            >
                <div
                    className={
                        "text-white  transition-all flex flex-row items-center justify-center gap-1 lg:gap-4 "
                    }
                >
                    {/* <img className="size-6" src={directions} /> */}
                    <ReactSVG
                        src={directions}

                        beforeInjection={(svg) => {

                            svg.querySelectorAll(
                                "path",
                            ).forEach((path) => {
                                path.setAttribute(
                                    "fill",
                                    props.iconColor ? props.iconColor : 'white'
                                );
                            });
                        }}
                    />
                    {" "}
                    {!props.onlyIcon && t("directions", { ns: "glossary" })}
                </div>
            </Button>
        </a>

    );
};

export default Directions;
